import React from 'react'
import { useConfigParam } from '../hooks/config'

export const useEmail = (): string => useConfigParam('contact_email')

export default ({ children }: { children?: any }) => {
  const email = useEmail()
  return <a href={`mailto:${email}`}>{children || email}</a>
}
